(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initSlider = (root) => {
    if (root.dataset.uncommonSliderReady === 'true') return;
    const track = root.querySelector('[data-uncommon-slider-track]');
    const slides = Array.from(root.querySelectorAll('[data-uncommon-slide], .uncommon-product-card'));
    const previous = Array.from(root.querySelectorAll('[data-uncommon-prev]'));
    const next = Array.from(root.querySelectorAll('[data-uncommon-next]'));
    const status = root.querySelector('[data-uncommon-slider-status]');
    if (!track || slides.length === 0) return;

    root.dataset.uncommonSliderReady = 'true';
    let frame = 0;

    const pad = (value) => String(value).padStart(2, '0');
    const positions = () => slides.map((slide) => Math.max(0, slide.offsetLeft - track.offsetLeft));
    const currentIndex = () => {
      const points = positions();
      return points.reduce((best, point, index) => (
        Math.abs(point - track.scrollLeft) < Math.abs(points[best] - track.scrollLeft) ? index : best
      ), 0);
    };

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const update = () => {
      frame = 0;
      const index = currentIndex();
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft >= maxScroll() - 1;
      if (status) status.textContent = pad(index + 1) + ' / ' + pad(slides.length);
      previous.forEach((button) => { button.disabled = atStart; });
      next.forEach((button) => { button.disabled = atEnd; });
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    const move = (direction) => {
      const index = Math.min(slides.length - 1, Math.max(0, currentIndex() + direction));
      const target = Math.min(positions()[index], maxScroll());
      track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    previous.forEach((button) => button.addEventListener('click', () => move(-1)));
    next.forEach((button) => button.addEventListener('click', () => move(1)));
    track.addEventListener('scroll', requestUpdate, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });

    if ('ResizeObserver' in window) new ResizeObserver(requestUpdate).observe(track);
    else window.addEventListener('resize', requestUpdate, { passive: true });

    update();
  };

  const init = (scope = document) => {
    if (scope.matches?.('[data-uncommon-slider]')) initSlider(scope);
    scope.querySelectorAll?.('[data-uncommon-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
